import { SvgIconProps } from '@mui/material'
import SvgIcon from '@mui/material/SvgIcon'
import { IconActive } from 'components/ArteelIcons/IconActive'

export const Location = ({ active, ...rest }: SvgIconProps & IconActive) => (
  <SvgIcon {...rest} viewBox="0 0 9.1 10.9">
    <path d="M8.1,4.3c0,1.4-1.7,4-2.8,5.4-.2.2-.5.4-.8.4s-.6-.1-.8-.4c-1-1.4-2.8-4-2.8-5.4s.7-2.4,1.8-3.1c1.1-.6,2.5-.6,3.6,0s1.8,1.8,1.8,3.1h0ZM6.5,4c0-.5-.2-1-.6-1.4-.4-.4-.9-.6-1.4-.6s-1,.2-1.4.6c-.4.4-.6.9-.6,1.4s.2,1,.6,1.4c.4.4.9.6,1.4.6.5,0,1-.2,1.4-.6.4-.4.6-.9.6-1.4h0Z" />
  </SvgIcon>
)
